import { commonFetch } from "./fetch";

// 获取字典列表
export function getDictionaryList(
  data: DictionaryParams
): Promise<DictionaryData> {
  return commonFetch(
    "/crm-mdm/v1/dictionary/dictdata/findByDictTypeCodeList",
    true,
    data
  );
}

const commonApi = {
  getDictionaryList,
}

export default commonApi;
